module.exports = __webpack_public_path__ + "img/W-M63.e5ecb6c4.jpg";